import React from "react"
import { MailButtonType } from "../../types"
import { useAccessibility } from "../../context/AccessibilityContext"
import IconButton from "./IconButton"
import { speakOutLoud } from "../../services/functions"


export default function MailButton(props: MailButtonType) {
    const { getCursorPointerClass } = useAccessibility()

    return (
        <div className={`flex gap-4 justify-center items-center w-full ${props?.classParent}`}>
            <button
                className={`py-2 flex items-center px-14 bg-secondary normal-case text-accent font-normal w-fit tracking-wide rounded-full shadow-lg text-base  lg:text-lg ${props.classProps}  ${getCursorPointerClass()}`}>
                <a
                href={'mailto:' + props.mail}>
                    E-Mail senden
                </a>
            </button>
            {/* <IconButton function={() => speakOutLoud('Email senden')} /> */}

        </div>
    )
}
